export * from "./EmptyTip";
export * from "./ErrorTip";
export * from "./LoadingTip";
export * from "./FoundTip";
export * from "./StatusTip";
//# sourceMappingURL=index.js.map